export enum ProcessType {
  BOLT = 1,
  WRENCH = 2,
  HARDHAT = 3,
  GEAR = 4,
  DATABASE = 5,
  ANCHOR = 6,
  ANVIL = 7,
  BARREL = 8,
  GATE = 9,
  BULLDOZER = 10,
  COG = 11,
  CONNECTION = 12,
  DOLLY = 13,
  TRUCK = 14,
  ENGINE = 15,
  FACTORY = 16,
  FAN = 17,
  FIREWIRE = 18,
  PIPE = 19,
  PUMP = 20,
  PROCESS = 21
}

export enum ProcessTypeIcon {
  BOLT = 'procedureTypes/bolt',
  WRENCH = 'procedureTypes/wrench',
  HARDHAT = 'procedureTypes/hard-hat',
  GEAR = 'procedureTypes/gear',
  DATABASE = 'procedureTypes/database',
  ANCHOR = 'procedureTypes/anchor',
  ANVIL = 'procedureTypes/anvil',
  BARREL = 'procedureTypes/barrel',
  GATE = 'procedureTypes/boom-gate',
  BULLDOZER = 'procedureTypes/bulldozer',
  COG = 'procedureTypes/cog',
  CONNECTION = 'procedureTypes/connection',
  DOLLY = 'procedureTypes/dolly',
  TRUCK = 'procedureTypes/dump-truck',
  ENGINE = 'procedureTypes/engine',
  FACTORY = 'procedureTypes/factory',
  FAN = 'procedureTypes/fan',
  FIREWIRE = 'procedureTypes/firewire',
  PIPE = 'procedureTypes/pipe-valve',
  PUMP = 'procedureTypes/pump',
  PROCESS = 'procedureTypes/process'
}

export enum ProcessSortCriteria {
  RELEVANCE = 'relevance',
  NAME = 'name',
  NEWEST = 'createdAt',
  UPDATED = 'updatedAt'
}

export const ProcessTypeColors = [
  '#00A9EB',
  '#0BCF97',
  '#F03D3D',
  '#6B5EAE',
  '#39AFD1',
  '#FF679B',
  '#FFBC00',
  '#6C757D'
]

export enum ProcessStatus {
  PUBLISHED = 'published',
  DRAFT = 'draft'
}

export enum ProcessDraftType {
  BOLT = 1,
  WRENCH = 2,
  HARDHAT = 3,
  GEAR = 4,
  DATABASE = 5,
  ANCHOR = 6,
  ANVIL = 7,
  BARREL = 8,
  GATE = 9,
  BULLDOZER = 10,
  COG = 11,
  CONNECTION = 12,
  DOLLY = 13,
  TRUCK = 14,
  ENGINE = 15,
  FACTORY = 16,
  FAN = 17,
  FIREWIRE = 18,
  PIPE = 19,
  PUMP = 20,
  PROCESS = 21
}

export enum ProcessDraftTypeIcon {
  BOLT = 'procedureTypes/bolt',
  WRENCH = 'procedureTypes/wrench',
  HARDHAT = 'procedureTypes/hard-hat',
  GEAR = 'procedureTypes/gear',
  DATABASE = 'procedureTypes/database',
  ANCHOR = 'procedureTypes/anchor',
  ANVIL = 'procedureTypes/anvil',
  BARREL = 'procedureTypes/barrel',
  GATE = 'procedureTypes/boom-gate',
  BULLDOZER = 'procedureTypes/bulldozer',
  COG = 'procedureTypes/cog',
  CONNECTION = 'procedureTypes/connection',
  DOLLY = 'procedureTypes/dolly',
  TRUCK = 'procedureTypes/dump-truck',
  ENGINE = 'procedureTypes/engine',
  FACTORY = 'procedureTypes/factory',
  FAN = 'procedureTypes/fan',
  FIREWIRE = 'procedureTypes/firewire',
  PIPE = 'procedureTypes/pipe-valve',
  PUMP = 'procedureTypes/pump',
  PROCESS = 'procedureTypes/process'
}

export enum EProcessTypeColors {
  BRAND = '#00A9EB',
  ROSE = '#FA5C7C',
  REGAL = '#727CF5',
  WARNING = '#E9AC00',
  AQUA_BOLD = '#02A8B5',
  AQUA = '#39AFD1',
  CITRUS = '#FD7E14',
  SUCCESS = '#0BCF97'
}

export const defaultIcons: { type: ProcessType; color: EProcessTypeColors }[] = Object.keys(ProcessType).map(
  (_, index) => ({
    type: (index + 1) as ProcessType,
    color: Object.values(EProcessTypeColors)[index % Object.values(EProcessTypeColors).length]
  })
)

export enum EViewModeLabel {
  EXPANDED_VIEW = 'Expanded view',
  LIST_VIEW = 'List view'
}
